const TYPES = {
  MEMBER: 'member',
  ARRAY: 'array',
  OBJECT: 'object',
  STRING: 'string',
  NUMBER: 'number',
  ENUM: 'enum',
  SELECT: 'select',
};

export {
  TYPES,
};



// WEBPACK FOOTER //
// ./src/Resources/types.js